export type MetricKind = 'int' | 'currency' | 'percent' | 'ratio';

export type CompareMetricDef = {
  key: string;
  label: string;
  kind: MetricKind;
  /** When true, value comes from parsed summary `rowCount`, not `totals`. */
  useRowCount?: boolean;
};

/** Order matches backend summarize_profile_rows totals (+ imported row count). */
export const REPORT_COMPARE_METRICS: CompareMetricDef[] = [
  { key: 'impressions', label: 'Impressions', kind: 'int' },
  { key: 'clicks', label: 'Clicks', kind: 'int' },
  { key: 'cost', label: 'Spend', kind: 'currency' },
  { key: 'purchases30d', label: 'Purchases (30d)', kind: 'int' },
  { key: 'sales30d', label: 'Sales (30d)', kind: 'currency' },
  { key: 'ctr', label: 'CTR', kind: 'percent' },
  { key: 'cpc', label: 'CPC', kind: 'currency' },
  { key: 'roas', label: 'ROAS', kind: 'ratio' },
  { key: 'rowCount', label: 'Imported rows in range', kind: 'int', useRowCount: true },
];

export type PctChangeResult =
  | { type: 'ok'; value: number }
  | { type: 'both_zero' }
  | { type: 'baseline_zero' };

export function percentChangeVsBaseline(current: number, baseline: number): PctChangeResult {
  if (baseline === 0) {
    if (current === 0) return { type: 'both_zero' };
    return { type: 'baseline_zero' };
  }
  return { type: 'ok', value: ((current - baseline) / baseline) * 100 };
}

export function getMetricValue(
  summary: { totals: Record<string, number>; rowCount: number },
  def: CompareMetricDef
): number | null {
  if (def.useRowCount) {
    const n = summary.rowCount;
    return typeof n === 'number' && Number.isFinite(n) ? n : null;
  }
  const v = summary.totals[def.key];
  if (typeof v !== 'number' || !Number.isFinite(v)) return null;
  return v;
}
